(() => {
  'use strict';
  const root = document.querySelector('[data-ch-library]');
  const preview = new URLSearchParams(location.search).get('view') ?.startsWith('clubhouse-') || false;
  // Preview navigation remains on the staged templates, including browser Back.
  if (preview) document.querySelectorAll('[data-ch-article-link], [data-ch-browse-link]').forEach(link => {
    const url = new URL(link.href, location.origin); url.searchParams.set('view', 'clubhouse-repair'); link.href = url;
  });
  if (!root) return;
  const hub = '/blogs/the-clubhouse';
  const legacy = location.pathname.match(/\/tagged\/(.+)$/);
  if (legacy) {
    const url = new URL(hub, location.origin);
    const tags = decodeURIComponent(legacy[1]).split('+');
    const age = tags.find(tag => /^age-(2-5|6-8|9-12)$/.test(tag));
    const topic = tags.find(tag => /^lane-/.test(tag));
    if (age) url.searchParams.set('age', age.slice(4));
    if (topic) url.searchParams.set('topic', topic.slice(5));
    if (preview) url.searchParams.set('view', 'clubhouse-repair');
    url.hash = 'guides'; location.replace(url); return;
  }
  const form = root.querySelector('[data-ch-search]');
  const input = form.querySelector('[name="q"]');
  const age = root.querySelector('[data-ch-age]');
  const topic = root.querySelector('[data-ch-topic]');
  const grid = root.querySelector('[data-ch-grid]');
  const cards = [...grid.querySelectorAll('[data-ch-card]')];
  const status = root.querySelector('[data-ch-status]');
  const heading = root.querySelector('#ch-results-title');
  const reset = root.querySelector('[data-ch-reset]');
  const empty = root.querySelector('[data-ch-empty]');
  const stop = new Set('a an the for of to in on at my me our your their his her i we you they it is are be do does should could would can need get what which how with and or golf kid kids child children please help'.split(' '));
  const aliases = {sizing:'size',sizes:'size',sized:'size',fit:'size',fitting:'size',height:'size',tall:'size',length:'size',clubs:'club',driver:'club',drivers:'club',balls:'ball',swinging:'swing',swings:'swing',lessons:'lesson',practice:'practice',practicing:'practice',games:'game',teaching:'teach',learning:'learn',rain:'indoor',rainy:'indoor',winter:'indoor',lefty:'handed',left:'handed',right:'handed',gripping:'grip',holding:'hold',frustrating:'frustrated',frustration:'frustrated'};
  const tokens = value => [...new Set((value.toLowerCase().match(/[a-z0-9]+/g) || []).filter(word => !stop.has(word)).map(word => aliases[word] || word))];
  const records = cards.map((card,index) => ({card,index,title:tokens(card.dataset.title),summary:tokens(card.dataset.summary),ages:card.dataset.ages.split(','),topic:card.dataset.topic}));
  const suggested = {'2-5':'how-to-teach-toddler-golf-swing-safely','6-8':'what-should-kids-bring-to-first-golf-lesson','9-12':'do-kids-need-full-set-golf-clubs'};
  const label = select => select.options[select.selectedIndex].textContent;
  function restore() {
    const params = new URLSearchParams(location.search);
    input.value = params.get('q') || '';
    age.value = [...age.options].some(o => o.value === params.get('age')) ? params.get('age') : '';
    topic.value = [...topic.options].some(o => o.value === params.get('topic')) ? params.get('topic') : '';
  }
  function save() {
    const url = new URL(hub,location.origin);
    if (input.value.trim()) url.searchParams.set('q',input.value.trim());
    if (age.value) url.searchParams.set('age',age.value);
    if (topic.value) url.searchParams.set('topic',topic.value);
    if (preview) url.searchParams.set('view','clubhouse-repair');
    url.hash = 'guides';
    if (url.href !== location.href) history.pushState(null,'',url);
  }
  let visibleLimit = 9;
  const more = root.querySelector('[data-ch-more]');
  function render() {
    const query = input.value.trim(); const terms = tokens(query);
    const ranked = records.map(record => {
      const hits = terms.filter(term => record.title.includes(term) || record.summary.includes(term));
      let score = terms.reduce((sum,term) => sum + (record.title.includes(term)?10:0) + (record.summary.includes(term)?2:0),0);
      // Sizing questions should lead to the size guide, not generic club mentions.
      if (terms.includes('size') && record.card.dataset.handle==='kids-golf-club-size-by-age-guide') score += 40;
      if (!query && age.value && record.card.dataset.handle===suggested[age.value]) score += 30;
      const specific = terms.filter(term => !['club','ball','start','first'].includes(term));
      const relevant = !terms.length || (hits.length > 0 && (!specific.length || specific.some(term => hits.includes(term))));
      return {...record,score,show:relevant && (!age.value || record.ages.includes(age.value)) && (!topic.value || record.topic===topic.value)};
    }).sort((a,b)=>b.score-a.score || a.index-b.index);
    let shown = 0;
    ranked.forEach(record=>{record.card.dataset.chMatch=String(record.show);record.card.hidden=!record.show || ++shown>visibleLimit;grid.append(record.card)});
    const count=ranked.filter(record=>record.show).length;
    const filters=[age.value?label(age):'',topic.value?label(topic):''].filter(Boolean);
    heading.textContent=query?'Your search results':age.value?`Start here for ${label(age).toLowerCase()}`:topic.value?label(topic):'Explore the guides';
    status.textContent=`${count} ${count===1?'guide':'guides'}${query?` for “${query}”`:''}${filters.length?` · ${filters.join(' · ')}`:''}`;
    more.hidden=count<=visibleLimit;more.textContent=`Show more guides (${Math.max(0,count-visibleLimit)} more)`;
    reset.hidden=!(query||age.value||topic.value);empty.hidden=count!==0;grid.hidden=count===0;
    root.querySelector('[data-ch-age-note]').hidden=!age.value;
  }
  function clear(event) {event?.preventDefault();visibleLimit=9;input.value='';age.value='';topic.value='';save();render();}
  form.addEventListener('submit',event=>{event.preventDefault();visibleLimit=9;save();render();heading.tabIndex=-1;heading.focus({preventScroll:true});heading.scrollIntoView({block:'start',behavior:'auto'})});
  [age,topic].forEach(select=>select.addEventListener('change',()=>{visibleLimit=9;save();render()}));
  input.addEventListener('search',()=>{if(!input.value){save();render()}});
  reset.addEventListener('click',clear);root.querySelector('[data-ch-clear]').addEventListener('click',clear);
  window.addEventListener('popstate',()=>{restore();render()});
  more.addEventListener('click',()=>{const oldLimit=visibleLimit;visibleLimit+=9;render();const next=[...grid.querySelectorAll('[data-ch-match="true"]')][oldLimit]?.querySelector('h3 a');next?.focus({preventScroll:true})});
  restore();render();root.querySelectorAll('[data-ch-enhancement]').forEach(node=>node.hidden=false);
})();
